export default "__VITE_ASSET__gNRc9iAm__"